const contactUsDefaults = {
  email: "",
  section: "",
  priority: "",
  issue: "",
  attachment: null,
};
const contactUsErrors = {
  email: "",
  section: "",
  priority: "",
  issue: "",
  attachment: "",
};

export { contactUsDefaults, contactUsErrors };
